export default __webpack_public_path__ + "static/wenjun2-ab9393872c050cc96e176d089529be86.jpg";